module.exports = "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,400,300,600);\ntextarea {\n  height: 110px; }\n"